import { a as __makeTemplateObject, c as __rest, _ as __assign, d as __extends } from './tslib.es6-86dc5b0c.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { Component } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { m as medium } from './breakpoints-70e05b67.js';
import { e as error } from './typography-fe8ea2dd.js';
import { C as ContextBubbleBackground, a as ContextBubbleAnimation } from './ContextBubble-cc3cfcf8.js';

var _path;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "Icon-stroke",
    d: "M16.986 1.014L.983 17.018m16.003-.032L.983.983",
    fill: "none",
    stroke: "#6273C9",
    strokeLinecap: "square"
  })));
}

var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgErrorMessagePointerBordered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 11
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "ErrorMessagePointer-stroke",
    d: "M0 10L13 0l13 10"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "ErrorMessagePointer-fill",
    d: "M0 11L13 1l13 10"
  }))));
}

var fadeIn = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from { opacity: 0; }\n  to { opacity: 1; }\n"], ["\n  from { opacity: 0; }\n  to { opacity: 1; }\n"])));
var fadeInOutShort = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  from { opacity: 0; visibility: visible; }\n  12.5% { opacity: 1; }\n  87.5% { opacity: 1; }\n  99% { opacity: 0; }\n  to { opacity: 0; visibility: hidden; }\n"], ["\n  from { opacity: 0; visibility: visible; }\n  12.5% { opacity: 1; }\n  87.5% { opacity: 1; }\n  99% { opacity: 0; }\n  to { opacity: 0; visibility: hidden; }\n"])));
var fadeInOut = keyframes(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  from { opacity: 0; visibility: visible; }\n  3% { opacity: 1; }\n  96% { opacity: 1; }\n  99% { opacity: 0; }\n  to { opacity: 0; visibility: hidden; }\n"], ["\n  from { opacity: 0; visibility: visible; }\n  3% { opacity: 1; }\n  96% { opacity: 1; }\n  99% { opacity: 0; }\n  to { opacity: 0; visibility: hidden; }\n"])));
var fadeOut = keyframes(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  from { opacity: 1; }\n  to { opacity: 0; }\n"], ["\n  from { opacity: 1; }\n  to { opacity: 0; }\n"])));
var Container = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n\n  animation-fill-mode: forwards;\n  animation-name: ", ";\n  animation-timing-function: ease;\n  border-radius: 4px;\n  opacity: 0;\n  padding: 12px 15px;\n  position: absolute;\n  visibility: hidden;\n  width: 298px;\n  z-index: 2;\n\n  ", "\n\n  ", "\n\n  a {\n    font-weight: bold;\n    text-decoration: none;\n\n    ", "\n  }\n\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  animation-fill-mode: forwards;\n  animation-name: ", ";\n  animation-timing-function: ease;\n  border-radius: 4px;\n  opacity: 0;\n  padding: 12px 15px;\n  position: absolute;\n  visibility: hidden;\n  width: 298px;\n  z-index: 2;\n\n  ", "\n\n  ", "\n\n  a {\n    font-weight: bold;\n    text-decoration: none;\n\n    ", "\n  }\n\n  ", "\n\n  ", "\n"])), error, fadeOut, function (_a) {
    var theme = _a.theme;
    return "\n    animation-duration: " + theme.transitionDurationPrimary + ";\n    border: 1px solid " + theme.contextBubbleBorderColor + ";\n    color: " + theme.contextBubbleForegroundColor + ";\n    transition: visibility " + theme.transitionDurationPrimary + " step-end;\n  ";
}, medium(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 330px;\n  "], ["\n    width: 330px;\n  "]))), function (_a) {
    var theme = _a.theme;
    return "\n      color: " + theme.contextBubbleForegroundColor + ";\n    ";
}, function (_a) {
    var background = _a.background, theme = _a.theme;
    switch (background) {
        case ContextBubbleBackground.DANGER:
            return "\n          background: " + theme.contextBubbleDangerBackgroundColor + ";\n        ";
        case ContextBubbleBackground.EMERGENCY_HOURS:
            return "\n          background: " + theme.contextBubbleEmergencyHoursBackgroundColor + ";\n        ";
        case ContextBubbleBackground.INVERT:
            return "\n          background: " + theme.contextBubbleInvertBackgroundColor + ";\n          border-color: " + theme.contextBubbleInvertBorderColor + ";\n          color: " + theme.contextBubbleInvertForegroundColor + ";\n        ";
        case ContextBubbleBackground.DEFAULT:
        default:
            return "\n          background: " + theme.contextBubbleBackgroundColor + ";\n        ";
    }
}, function (_a) {
    var animation = _a.animation, isVisible = _a.isVisible, theme = _a.theme;
    if (isVisible) {
        var isShort = animation === ContextBubbleAnimation.FADE_IN_OUT_SHORT;
        switch (animation) {
            case ContextBubbleAnimation.FADE_IN_OUT:
            case ContextBubbleAnimation.FADE_IN_OUT_SHORT:
                return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n            animation-duration: ", ";\n            animation-fill-mode: forwards;\n            animation-name: ", ";\n            animation-timing-function: ease;\n          "], ["\n            animation-duration: ", ";\n            animation-fill-mode: forwards;\n            animation-name: ", ";\n            animation-timing-function: ease;\n          "])), isShort ? '2s' : '7.5s', isShort ? fadeInOutShort : fadeInOut);
            case ContextBubbleAnimation.FADE_IN:
            default:
                return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n            animation-duration: ", ";\n            animation-fill-mode: forwards;\n            animation-name: ", ";\n            animation-timing-function: ease;\n            transition: visibility ", " step-start;\n            visibility: visible;\n          "], ["\n            animation-duration: ", ";\n            animation-fill-mode: forwards;\n            animation-name: ", ";\n            animation-timing-function: ease;\n            transition: visibility ", " step-start;\n            visibility: visible;\n          "])), theme.transitionDurationPrimary, fadeIn, theme.transitionDurationPrimary);
        }
    }
    else {
        return '';
    }
});
var ClosableContainer = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var isClosableByX = _a.isClosableByX;
    return isClosableByX ? 'padding-right: 20px;' : '';
});
var CloseButton = styled.button(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  height: 35px;\n  margin: 0;\n  padding: 10px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 35px;\n\n  ", "\n"], ["\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  height: 35px;\n  margin: 0;\n  padding: 10px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 35px;\n\n  ", "\n"])), function (_a) {
    var isInverted = _a.isInverted, theme = _a.theme;
    return "\n    [data-svg-class=\"Icon-stroke\"] {\n      stroke: " + (isInverted
        ? theme.contextBubbleInvertBorderColor
        : theme.contextBubbleForegroundColor) + ";\n    }\n  ";
});
var PointerSvgWithProps = function (_a) {
    _a.background; _a.pointer; var props = __rest(_a, ["background", "pointer"]);
    return jsx(SvgErrorMessagePointerBordered, __assign({}, props), void 0);
};
var Pointer = styled(PointerSvgWithProps)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  height: 11px;\n  position: absolute;\n  width: 26px;\n\n  [data-svg-class='ErrorMessagePointer-stroke'] {\n    ", "\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  height: 11px;\n  position: absolute;\n  width: 26px;\n\n  [data-svg-class='ErrorMessagePointer-stroke'] {\n    ", "\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n      fill: " + theme.contextBubbleBorderColor + ";\n    ";
}, function (_a) {
    var _b = _a.pointer, anchor = _b.anchor, horizontal = _b.horizontal;
    if (horizontal === 'center') {
        return "\n        left: 50%;\n        margin-left: -13px;\n      ";
    }
    else if (typeof horizontal === 'number') {
        if (anchor === 'right') {
            return "\n          right: " + horizontal + "px;\n        ";
        }
        else {
            return "\n          left: " + horizontal + "px;\n        ";
        }
    }
    return '';
}, function (_a) {
    var vertical = _a.pointer.vertical;
    if (vertical === 'top') {
        return "\n        top: -11px;\n      ";
    }
    else {
        return "\n        bottom: -11px;\n        transform: scale(1, -1);\n      ";
    }
}, function (_a) {
    var background = _a.background, theme = _a.theme;
    switch (background) {
        case ContextBubbleBackground.DANGER:
            return "\n          [data-svg-class=\"ErrorMessagePointer-fill\"] {\n            fill: " + theme.contextBubbleDangerBackgroundColor + ";\n          }\n        ";
        case ContextBubbleBackground.EMERGENCY_HOURS:
            return "\n          [data-svg-class=\"ErrorMessagePointer-fill\"] {\n            fill: " + theme.contextBubbleEmergencyHoursBackgroundColor + ";\n          }\n        ";
        case ContextBubbleBackground.INVERT:
            return "\n          [data-svg-class=\"ErrorMessagePointer-stroke\"] {\n            stroke: " + theme.contextBubbleInvertBorderColor + ";\n          }\n          [data-svg-class=\"ErrorMessagePointer-fill\"] {\n            fill: " + theme.contextBubbleInvertBackgroundColor + ";\n          }\n        ";
        case ContextBubbleBackground.DEFAULT:
        default:
            return "\n          [data-svg-class=\"ErrorMessagePointer-fill\"] {\n            fill: " + theme.contextBubbleBackgroundColor + ";\n          }\n        ";
    }
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;

var ContextBubble = /** @class */ (function (_super) {
    __extends(ContextBubble, _super);
    function ContextBubble(props) {
        var _this = _super.call(this, props) || this;
        _this.thisRef = null;
        _this.isVisible = function () {
            return _this.state.isActive && _this.props.isEnabled !== false;
        };
        _this.close = function () {
            _this.privateDoNextAnimation(false);
        };
        _this.doNextAnimation = function () {
            _this.privateDoNextAnimation();
        };
        // To use this, you need to also wrap an empty event handler at your root app as a workaround to the referenced bug
        // https://stackoverflow.com/questions/34608913/angular-issue-with-ng-blur-on-iphone-ipad/35962077
        _this.onBlur = function (event) {
            if (_this.props.isClosableByBlur && _this.thisRef) {
                var clickedElement = event.relatedTarget || event.target;
                var contextBubbleParent = _this.thisRef.parentNode || _this.thisRef.parentElement;
                // We assume sibling/children elements of contextbubble should not trigger blur.
                if (!clickedElement ||
                    (contextBubbleParent && !contextBubbleParent.contains(clickedElement))) {
                    _this.handleClose();
                }
            }
        };
        _this.handleClose = function () {
            var onCloseClick = _this.props.onCloseClick;
            if (onCloseClick) {
                onCloseClick();
                _this.close();
            }
            else {
                _this.close();
            }
        };
        _this.privateDoNextAnimation = function (isActive) {
            clearTimeout(_this.animationInProgress);
            if (typeof isActive !== 'undefined') {
                _this.setState({ isActive: isActive });
            }
            else if (_this.props.reclickBehavior === 'reshow') {
                _this.animationInProgress = window.setTimeout(function () {
                    _this.doOpenAnimation();
                }, 100);
                _this.setState({ isActive: false });
            }
            else if (_this.props.reclickBehavior === 'toggle') {
                if (!_this.state.isActive) {
                    _this.queueDeactivation();
                }
                _this.setState({ isActive: !_this.state.isActive });
            }
            else {
                _this.setState({ isActive: true });
            }
        };
        _this.getAnimationTime = function () {
            switch (_this.props.animation) {
                case ContextBubbleAnimation.FADE_IN_OUT_SHORT:
                    return 2000;
                case ContextBubbleAnimation.FADE_IN_OUT:
                    return 7000;
                default:
                    return 0;
            }
        };
        _this.animationInProgress = 0;
        _this.state = {
            isActive: _this.props.isOpenByDefault !== false,
        };
        return _this;
    }
    ContextBubble.prototype.componentDidMount = function () {
        var _this = this;
        // TODO: For efficiency, attach/deattach blur handler only on notVisible/Visible transition and vice versa
        if (this.props.isClosableByBlur && this.thisRef) {
            this.handleBlur = function (event) {
                _this.onBlur(event);
            };
            window.addEventListener('mouseup', this.handleBlur);
        }
    };
    ContextBubble.prototype.componentWillUnmount = function () {
        if (this.handleBlur) {
            window.removeEventListener('mouseup', this.handleBlur);
        }
    };
    ContextBubble.prototype.doOpenAnimation = function () {
        this.queueDeactivation();
        this.setState({ isActive: true });
    };
    ContextBubble.prototype.queueDeactivation = function () {
        var _this = this;
        var animationTime = this.getAnimationTime();
        if (animationTime) {
            this.animationInProgress = window.setTimeout(function () {
                _this.setState({ isActive: false });
            }, animationTime);
        }
    };
    ContextBubble.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.animation, animation = _b === void 0 ? ContextBubbleAnimation.FADE_IN : _b, _c = _a.background, background = _c === void 0 ? ContextBubbleBackground.DEFAULT : _c, children = _a.children, _d = _a.className, className = _d === void 0 ? '' : _d; _a.isClosableByBlur; var isClosableByX = _a.isClosableByX; _a.isOpenByDefault; _a.reclickBehavior; _a.isEnabled; _a.onCloseClick; var pointer = _a.pointer, props = __rest(_a, ["animation", "background", "children", "className", "isClosableByBlur", "isClosableByX", "isOpenByDefault", "reclickBehavior", "isEnabled", "onCloseClick", "pointer"]);
        return (jsx(Container, __assign({ animation: animation, background: background, className: className, isVisible: this.isVisible(), ref: function (divElement) { return (_this.thisRef = divElement); }, role: "tooltip", tabIndex: -1 }, props, { children: jsxs(ClosableContainer, __assign({ isClosableByX: !!isClosableByX }, { children: [children, pointer && jsx(Pointer, { background: background, pointer: pointer }, void 0), isClosableByX && (jsx(CloseButton, __assign({ isInverted: background === ContextBubbleBackground.INVERT, onClick: this.handleClose }, { children: jsx(SvgClose, {}, void 0) }), void 0))] }), void 0) }), void 0));
    };
    return ContextBubble;
}(Component));

export { ContextBubble as C };
